import { useFeature } from "../features";

export const useTransfersPermission = () => {
  const { featureEnabled } = useFeature();
  return featureEnabled("transfers_redesign") && featureEnabled("transfers");
};
